module.exports = __webpack_public_path__ + "static/NotoSansThai-Regular.subset-991573cedba55de0e87e929225d422b2.woff";